import { render, staticRenderFns } from "./RevisionModal.vue?vue&type=template&id=55782caf&"
import script from "./RevisionModal.vue?vue&type=script&lang=js&"
export * from "./RevisionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55782caf')) {
      api.createRecord('55782caf', component.options)
    } else {
      api.reload('55782caf', component.options)
    }
    module.hot.accept("./RevisionModal.vue?vue&type=template&id=55782caf&", function () {
      api.rerender('55782caf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/responsible/planing/absences/components/RevisionModal.vue"
export default component.exports